// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ol-map {
  min-width: 200px;
  min-height: 500px;
  height: 500px;
  width: "100%";
}

.ol-control {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 4px;
  padding: 2px;
}

.ol-full-screen {
  top: 0.5em;
  right: 0.5em;

  @media (max-width: 992px) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../components3/src/OLMap/Map/Map.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;;EAEZ;IACE,aAAa;EACf;AACF","sourcesContent":[".ol-map {\n  min-width: 200px;\n  min-height: 500px;\n  height: 500px;\n  width: \"100%\";\n}\n\n.ol-control {\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.ol-full-screen {\n  top: 0.5em;\n  right: 0.5em;\n\n  @media (max-width: 992px) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
